import React from 'react';
import { useTranslation } from 'utils/translation';
import Info from '../Info/Info';
import Spacer from '../Spacer/Spacer';
import Typography from '../Typography/Typography';

type Props = {
  message?: string;
  description?: string;
};

const Empty = ({ message, description }: Props) => (
  <>
    <Info message={message} type={'primary'} />
    {description && (
      <>
        <Spacer size={2} />
        <Typography variant="label2">{description}</Typography>
      </>
    )}
  </>
);

const Directory = () => {
  const { t } = useTranslation();

  return <Empty message={t('directory_is_empty')} />;
};

const General = () => {
  const { t } = useTranslation();

  return <Empty message={t('no_data_found')} />;
};

export default Object.assign(Empty, {
  Directory,
  General,
});
